import CButton from "../../../../../components/buttons/Button";

const WrongOtp = (props)=>{
    return(
        <>
        <div className="row py-5">
        <div className="col-md-4 col-sm-12"></div>
        <div className="col-md-4 col-sm-12 text-center mt-5" style={{minHeight:"100vh"}}>
          <span className="text-danger mt-5 mb-5 fw-bolder">
          Please enter the valid Verification Code
          </span>
          <br></br>
          <span className="text-danger mb-5 fw-bolder">send to your Email.</span>
          <CButton
            btnClassesDiv={"text-center mt-5"}
            btnClasses={"btn px-4 fw-bold text-white mt-5"}
            IsOutline={false}
            innertext={"Done"}
            btnCustomStyle={{
              backgroundColor: "#044389",
            }}
            functionName = {() => props.setFlagZero()}
          />
        </div>
        <div className="col-md-4 col-sm-12"></div>
      </div>
        </>
    )
    };
    
    export default WrongOtp;